var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.6667H13.3333C13.7015 12.6667 14 12.9652 14 13.3334V13.3334C14 13.7015 13.7015 14 13.3333 14H6V12.6667Z",
    fill: "#009866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0465 2.78285C11.0051 1.74142 9.31666 1.74141 8.27525 2.78282L2.783 8.27506C1.71798 9.34009 1.74573 11.0752 2.84426 12.1056L4.28676 13.4587C4.65749 13.8064 5.14672 14 5.65503 14H6.11528C6.64571 14 7.15441 13.7893 7.52948 13.4142L13.2181 7.72573C14.2595 6.68435 14.2595 4.99592 13.2181 3.95451L12.0465 2.78285ZM9.21806 3.72563C9.73876 3.20492 10.583 3.20493 11.1037 3.72565L12.2753 4.8973C12.796 5.41801 12.796 6.26222 12.2753 6.78291L10.0009 9.05729L6.94362 6.00006L9.21806 3.72563ZM6.00081 6.94287L3.72581 9.21787C3.1933 9.75039 3.20717 10.6179 3.75644 11.1332L5.19894 12.4862C5.32252 12.6021 5.48559 12.6666 5.65503 12.6666H6.11528C6.29209 12.6666 6.46166 12.5964 6.58668 12.4714L9.05803 10.0001L6.00081 6.94287Z",
    fill: "#36575F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.cb95bd0298f73b1b90337384fe429ba2.svg";
export { ForwardRef as ReactComponent };